/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { ToUserNamePipe, ToUserRolesPipe, User } from '@administration-client/user-shared';
import { ConvertForDataTestPipe } from '@common/tech-shared';
import { Component, Input } from '@angular/core';
import { ListItemComponent } from '@ods/system';
import { UserDataComponent } from './user-data/user-data.component';
import { UserOrganisationsEinheitenComponent } from './user-organisations-einheiten/user-organisations-einheiten.component';
import { UserRolesComponent } from './user-roles/user-roles.component';

@Component({
  selector: 'administration-user',
  imports: [
    ListItemComponent,
    ToUserNamePipe,
    UserOrganisationsEinheitenComponent,
    UserDataComponent,
    UserRolesComponent,
    ToUserRolesPipe,
    ConvertForDataTestPipe,
  ],
  templateUrl: './user.component.html',
})
export class UserComponent {
  @Input() user: User;
}
